import type { ViewMode } from '@/components/ui/CViewToggle.vue'

/**
 * Cards/rows choice of a listing page, remembered in localStorage per listing.
 * The server always renders cards; the saved choice is applied in onMounted so hydration matches.
 */
export function useListingViewMode(listing: string) {
    const storageKey = `growni_view_mode_${listing}`
    const viewMode = useState<ViewMode>(`listing-view-mode-${listing}`, () => 'cards')

    onMounted(() => {
        try {
            const saved = localStorage.getItem(storageKey)
            if (saved === 'cards' || saved === 'rows') viewMode.value = saved
        } catch {
            // Storage blocked (private mode, disabled cookies): keep the current mode
        }
    })

    watch(viewMode, (mode) => {
        try {
            localStorage.setItem(storageKey, mode)
        } catch {
            // Storage blocked: the choice just isn't remembered
        }
    })

    return viewMode
}
